import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

// Test comment


const LoginForm = () => {
  const navigate = useNavigate();
  const [vendor, setVendor] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); 

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      console.log(window.APP_CONFIG?.API_URL);
      const apiURL=window.APP_CONFIG?.API_URL+'admin/login';  
      const response = await api.post(apiURL,  {vendor, password});
      if (response.status === 200) {
        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('nameSupp', response.data.nameSupp);
        console.log('Supplier Name:', response.data.nameSupp);
        navigate('/menu');
      } 

    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          setError('Unauthorised: Invalid Password')
        } else if (error.response.status === 404) {
          setError('Unauthorised: Invalid User')
        }
      } else if (error.request) {
        setError('No response from server');
      } else {
        setError(error.message);
      }

      //setError(error.message);
    }
  }

  return (
    <div className='login__body'>
    <div className='login-container'>
      <img src='images/sunshinetradeexpo.jpg' alt='Sunshine'/>
      <form  onSubmit={handleSubmit}>
        <div className='form-group'>
          <label className='login__label'>Vendor Code:</label>
          <input
            className='login__input'
            type="text"
            value={vendor}
            onChange={(e) => setVendor(e.target.value)}
          />
        </div>      
        <div className='form-group'>
          <label className='login__label'>Password:</label>
          <input
            className='login__input'
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
    </div>
  );
};


export default LoginForm;